'use strict';

import VZTcBaseCard from './VZTcBaseCard';

export default class VZTcAssistedFlow extends VZTcBaseCard {}

if (!window.customElements.get('vz-tc-assisted-flow')) {
    window.customElements.define('vz-tc-assisted-flow', VZTcAssistedFlow);
}
